import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3535 11.3535L9 14.707L5.64648 11.3535L6.35352 10.6465L9 13.293L11.6465 10.6465L12.3535 11.3535Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 6V14H8.5V6H9.5Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 6C10.5 6.82843 9.82843 7.5 9 7.5C8.17157 7.5 7.5 6.82843 7.5 6C7.5 5.17157 8.17157 4.5 9 4.5C9.82843 4.5 10.5 5.17157 10.5 6Z",
			fill: "black"
		})
	]
});
export default SvgMass;
